import { render, staticRenderFns } from "./couponDetailManageList.vue?vue&type=template&id=5d29ee38&scoped=true"
import script from "./couponDetailManageList.vue?vue&type=script&lang=js"
export * from "./couponDetailManageList.vue?vue&type=script&lang=js"
import style0 from "./couponDetailManageList.vue?vue&type=style&index=0&id=5d29ee38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d29ee38",
  null
  
)

export default component.exports